const displayUpdatedFinancials = (supplier) =>
  supplier?.KeyFinancials?.totalAssets?.some?.((item) => !!item);

export default displayUpdatedFinancials;
